import Vue from 'vue'
export var eventBus = new Vue();


// WEBPACK FOOTER //
// ./src/assets/js/eventBus.js